<template>
  <div class="leaderboard-loading-indicator">
    <div class="text-center">
      <div class="quiz--result">
        {{ $t("loadingResult") }}...
      </div>
      <Loading style="margin: 0 auto" />
    </div>
  </div>
</template>
<script>
import Loading from '@/components/Loading'

export default {
  name: 'LeaderboardLoader',
  components: {
    Loading,
  },
}
</script>
<style lang="scss" scoped>
.leaderboard-loading-indicator {
  margin-top: 15%;
}
</style>
